<script setup>
import router from "@/router";
import {computed, defineProps, ref, watch} from "vue";
import {couponConf} from "@/utils/config";

const type = computed(() => couponConf.jdxc)
const props = defineProps({
  couponLst: {
    type: Array,
    default: () => {
      return [];
    },
  },
  account: {
    type: Object,
    default: () => {
      return {};
    },
  }
});
// const emit = defineEmits(["login"]);
const coupSelected = ref(0);
const selectedCopon = computed(() => {
  if(props.couponLst.length) return props.couponLst[coupSelected.value].data;
  else return [];
})
watch(() => props.couponLst, () => {
  coupSelected.value = 0;
})
const gift = require("@/assets/images/gift.png")
</script>

<template>
  <div class="coupon-list">
    <div class="coupon-cats-lst">
      <div class="coupon-cats-items" v-for="(cat,inx) in props.couponLst" :class="coupSelected === inx?'actives':''"
           :key="inx" @click="coupSelected=inx">
        {{ cat.name }}
      </div>
    </div>
    <el-card v-for="(item,inx) in selectedCopon" :key="inx" class="coupon-lst">
      <div class="coupon-content-items">
        <div class="coupon-content-coupon-image">
          <el-image :src="type.coupon"/>
          <div class="coupon-content-logo-values">
            <div>{{ item.name }}</div>
            <div>原价{{ item.face_value }}元</div>
          </div>
        </div>
        <div class="coupon-content-info">
          <div class="coupon-content-info-title">
<!--            <h5>{{ type?.name }}</h5>-->
            <h5>{{ item.title }}</h5>
          </div>
          <div class="coupon-content-info-price">
            <div class="coupon-content-info-price-value">
              <p class="face_values">
                <b class="face_value_discount">{{ item?.score_data?.scal?.discount }}</b>
                <span class="face_value_unit">{{ item?.score_data?.scal?.unit }}</span>
                <span class="discount-tag"
                      v-if="parseFloat(item?.score_data?.scal?.total) > parseFloat(item?.score_data?.scal?.discount)">活动价</span>
              </p>
              <p class="discount-unit-data"
                 v-if="parseFloat(item?.score_data?.scal?.total) > parseFloat(item?.score_data?.scal?.discount)">
                {{ item?.score_data?.scal?.total }}{{ item?.score_data?.scal?.unit }}
              </p>
            </div>
            <div class="coupon-btn">
              <el-button type="danger" color="#E12020" round v-if="Object.keys(props.account).length < 1 || (parseFloat(props.account.balance_miles) >= item?.score_data?.scal?.discount)"
                         @click="router.push({name:'detail',params:{id:item.id}})">立即兑换
              </el-button>
              <el-button type="info" round v-else disabled>里程不足</el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="active" v-if="item.active">
        <div class="active-img">
          <el-image :src="gift"/>
        </div>
        <div class="active-content">
          <div class="recharge-content-values-title" v-for="(act,inx) in item.active" :key="inx">
            <el-text type="danger">{{ act.title }}</el-text>
          </div>
        </div>
      </div>
    </el-card>
  </div>
  <div class="recharge-content">
    <div class="recharge-content-title recharge-content-values">兑换须知</div>
    <div class="recharge-content-values">
      <div class="recharge-content-values-info" v-for="(vals,inx) in type.desc" :key="inx">
        <h4 v-if="vals.title.length">{{ vals.title }}</h4>
        <ol class="recharge-content-values-items">
          <li v-for="(cont,i) in vals.content" :key="i" v-html="cont"></li>
        </ol>
      </div>
    </div>
  </div>
</template>

<style scoped lang="less">
.coupon-list {
  padding: 15px;
  box-sizing: border-box;

  .coupon-cats-lst {
    display: flex;
    margin-bottom: 15px;
    overflow-x: auto;

    .coupon-cats-items {
      flex: 0 0 80px;
      width: 80px;
      text-align: center;
      background: #ffffff;
      border-radius: 45px;
      line-height: 2;
      font-size: .9rem;

      &.actives {
        background: var(--theme-active-cat-btn);
        box-shadow: var(--el-box-shadow);
      }

      & + .coupon-cats-items {
        margin-left: 10px;
      }
    }
  }

  .coupon-lst {
    border-radius: 12px;

    .coupon-content-items {
      display: flex;

      .coupon-content-coupon-image {
        flex-basis: 120px;
        width: 120px;
        margin-right: 15px;
        position: relative;

        .coupon-content-logo-values {
          font-size: .8rem;
          line-height: 1.75;
          position: absolute;
          //z-index: 9999;
          left: 0;
          right: 0;
          text-align: center;
          top: 50px;
          color: #ffffff;
        }
      }

      .coupon-content-info {
        flex-basis: calc(100% - 120px);

        .coupon-content-info-price {
          display: flex;
          justify-content: space-between;
          align-items: center;

          .coupon-content-info-price-value {
            margin-top: 18px;

            .face_values {
              position: relative;

              .face_value_discount {
                font-size: 1.55rem;
                color: #E31D1A;
              }

              .face_value_unit {
                font-size: .8rem;
              }

              .discount-tag {
                position: absolute;
                right: -20px;
                top: -15px;
                font-size: .7rem;
                margin-bottom: 10px;
                background: #E31D1A;
                color: #ffffff;
                padding: 5px;
                border-radius: 8px 5px 8px;
              }
            }

            .discount-unit-data {
              color: var(--el-color-info);
              text-decoration: line-through;
            }
          }
        }
      }
    }

    & + .coupon-lst {
      margin-top: 15px;
    }

    .coupon-content-info {
      .coupon-content-info-title {
        line-height: 1.75;
      }
    }
  }
}

.recharge-content {
  background: #ffffff;
  border-radius: 12px;
  margin: 15px;
  overflow: hidden;

  .recharge-content-values {
    padding: 15px;

    .recharge-content-values-info {
      line-height: 2;
      text-align: justify;

      .recharge-content-values-items {
        padding-left: 20px;
        font-size: .8rem;
      }
    }

    &.recharge-content-title {
      background: var(--theme-toolbar-card-color);
      color: #ffffff;
      font-size: 1.2rem;
    }
  }
}

.active{
  display: flex;
  align-items: center;
  margin-top: 10px;

  .active-img{
    width: 30px;
    flex-basis: 30px;
    margin-right: 10px;
    line-height: 1.7;
  }
}
</style>
